import {Component} from 'preact'
import {connect} from 'preact-redux'

import FooterButton from './FooterButton/FooterButton'
import CustomizationModel from '/chat/src/redux/model/customization/model';
import SystemModel from '/chat/src/redux/model/system/model';
import FeaturesModel from '/chat/src/redux/model/features/model';

import style from './style.scss'

class Footer extends Component {
    render() {
        return (
            <div className={style.FooterContainer}
                style={{height: `${this.props.height}px`, width: `${this.props.width}px`}}>
                <div className={style.FooterButton}>
                    <FooterButton
                        orientation='left'
                        text={this.props.label}
                        active={this.props.activeTab === 0}
                        color={this.props.color}
                        onClick={() => this.props.dispatch(SystemModel.setActiveTab(0))}
                        imgSrc='/common/assets/images/help_desk_sm.svg'
                        />
                </div>
                <div className={style.FooterButton}>
                    <FooterButton
                        orientation='right'
                        text={this.props.language.get('Chat')}
                        index={1}
                        active={this.props.activeTab === 1}
                        color={this.props.color}
                        onClick={() => this.props.dispatch(SystemModel.setActiveTab(1))}
                        imgSrc='/common/assets/images/chatt_sm.svg'
                        />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const features = FeaturesModel.getActiveFeatures(state);
    const language = CustomizationModel.getLanguage(state);

    let label = '';
    const faqType = features['faq_type'];
    switch(faqType) {
        case 'helpdesk':
            label = 'Helpdesk'
            break;
        case 'faq':
        default:
            label = language.get("QuestionsAndAnswers")
    }

    return {
        activeTab: SystemModel.getActiveTab(state),
        color: CustomizationModel.getColor(state),
        width: SystemModel.getShellWidth(state),
        label: label,
        language: language
    }
}

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./routes/Footer/Footer.js